/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import "./styles.scss"

const Layout = ({ children, bgcolor }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} bgcolor={bgcolor} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0px 1.0875rem 1.45rem`,
          paddingTop: 0,
        }}
      >
        <main>
          {children}
          <hr style={{background: bgcolor}} />
        </main>


        <footer>
          © {new Date().getFullYear()},
          {' '}
          mkl public relations<br />
          3075 east kennedy drive, #312<br />
          salt lake city, utah  84108<br />
          main 801.328.8899<br /> mobile 801.209.3029<br />
          <a href="mailto:mkl@mklpr.com">mkl@mklpr.com</a><br />

        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
